exports.components = {
  "component---src-pages-auth-validate-account-tsx": () => import("./../../../src/pages/auth/validate-account.tsx" /* webpackChunkName: "component---src-pages-auth-validate-account-tsx" */),
  "component---src-templates-default-tsx": () => import("./../../../src/templates/default.tsx" /* webpackChunkName: "component---src-templates-default-tsx" */)
}

